<template>
  <div class="ax-list">
    <div class="type-box">
      <div class="type-text">
        <slot name="left" />
      </div>
    </div>
    <div class="content-box">
      <div class="contents-content">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ax-list'
};
</script>
<style lang="scss" scoped>
.ax-list{
  width: 100%;
  display: flex;
  background-color: #fff;
  align-items: center;
  padding-left: 4px;
  box-sizing: border-box;
  .type-box {
    width: 76px;
    height: 48px;
    font-size: 15px;
    color: #fff;
    display: flex;
    justify-content: center;
    .type-text{
      box-sizing: border-box;
      width: 48px;
      height: 48px;
      background: #1485EE;
      border-radius: 4px;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 6px;
      letter-spacing: 6px;
    }
  }
  .content-box{
    flex: 1;
    max-width: calc(100% - 76px);
    display: flex;
    padding: 12px 0;
    border-bottom: 1px solid $border-color;
  }
  .contents-content {
    flex: 1;
    max-width: calc(100% - 20px);
    h6 {
      font-size: 17px;
      height: 24px;
      line-height: 24px;
      color: $value-color;
      font-weight: normal;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 3px;
    }
    p {
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      color: $title-color;
      display: flex;
      align-items: center;
      span {
        display: block;
        padding: 0 4px;
        text-align: center;
        margin-left: 16px;
        border-radius: 6px;
        color: #ff8580;
        background: #ffeceb;
        height: 16px;
        line-height: 16px;
        &.status-ing {
          background-color: #ebf6ff;
          color: #70b3f6;
        }
        &.status-pass {
          background-color: #e5fffa;
          color: #65d5c1;
        }
        &.status-reject {
          background-color: #ffeeea;
          color: #f49379;
        }
      }
    }
  }
}
</style>
